var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"mainbar"},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"/"}},[_c('svg',{staticClass:"logo-svg"},[_c('use',{attrs:{"xlink:href":"static/sprite.svg#logo"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109dcb2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainBar.vue
// module id = 168
// module chunks = 0